import React from 'react';
import './OutroWrong.css';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import Heading from '../Heading/Heading';

const OutroWrong = ({ language, location }) => {

     // get translations
    const {t} = useTranslation();

    // render html
    return(
        <div className={`outroWrong`}>
            <div className={`outroWrong__box`}>
                <Heading>{ t('outro_wrong_title') }</Heading>
                <p>{ t('outro_wrong_description') }</p>
                <div className={`outroWrong__actions`}>
                    <Button path={`/${location}/${language}/question`}>{ t('outro_wrong_retry') } <span>»</span></Button>
                    <Button path={`/${location}/${language}/answer`} type="light">{ t('outro_wrong_showanswer') } <span>»</span></Button>
                </div>
            </div>
        </div>
    );
}

export default OutroWrong;